import { render, staticRenderFns } from "./ForecastMatrix.vue?vue&type=template&id=038eb3c6&"
import script from "./ForecastMatrix.vue?vue&type=script&lang=js&"
export * from "./ForecastMatrix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports